module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1010-4482820ad25f02db51cc1502c2325a98.png";